/**
 * Defers background/poster videos until they're actually near the viewport.
 * Sections wrap their <video> in `.skg-autoplay-on-view` and drop the
 * `autoplay` HTML attribute + use `preload: 'none'` — the browser then does
 * zero network work for that video until this observer calls .play() on it,
 * which only happens once it's about to scroll into view.
 */
(function () {
  function init() {
    // Observe the <video> elements themselves, NOT the `.skg-autoplay-on-view`
    // wrapper — the wrapper is `display: contents` (so it doesn't disturb the
    // existing absolute-positioning CSS on the video), which means it has no
    // layout box at all. IntersectionObserver can't compute intersection for
    // an element with no geometry, so observing the wrapper silently never
    // fires and the video never plays.
    var videos = document.querySelectorAll(".skg-autoplay-on-view video");
    if (!videos.length) return;

    if (typeof IntersectionObserver === "undefined") {
      videos.forEach(function (v) {
        v.play().catch(function () {});
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting) {
            v.play().catch(function () {});
          } else {
            try {
              v.pause();
            } catch (e) {}
          }
        });
      },
      { root: null, rootMargin: "200px 0px 200px 0px", threshold: 0.01 }
    );

    videos.forEach(function (v) {
      io.observe(v);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
